/**************************************************
 * Nombre:       Tarjeta_Colecciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useNavigate} from "react-router";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Colecciones = ({item}) => {
    const {sCell} = useResponsive()
    const navigate = useNavigate()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{
                    color: theme.palette.primary.main,
                    fontSize: sCell ? 32 : 48,
                    fontFamily: "Dm Serif Display",
                    fontWeight: 400,
                }}
                >{item.nombre}</Typography>
            </Grid>


            <Grid container size={12} sx={{mt: 1}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        background: `linear-gradient(145deg, #000 0%, rgba(0, 0, 0, 0.00) 59.46%), url(${item.img})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        color: '#fff',
                        p: sCell ? 3 : 6,
                        height: 550

                    }}

                >

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 6, sm: 4, md: 3}}>
                            <Typography sx={{fontWeight: 300, fontSize: sCell ? 16 : 18, lineHeight: 1.5}}>
                                {item.descripcion}
                            </Typography>
                        </Grid>

                        <Grid container size={12} sx={{mt: 4}}>
                            <Button
                                onClick={() => navigate('/DetalleCol/' + item.id)}
                                sx={{
                                    backgroundColor: '#ffffff40',
                                    border: 1,
                                    borderColor: '#fff',
                                    boxShadow: 0,
                                    px: 6
                                }}>Ver colección</Button>
                        </Grid>


                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Colecciones